import { Component, EventEmitter, Output } from '@angular/core';

/**
 * Shown once, right after `updateAgreementDocument()` succeeds, to guide a
 * newly agreed restaurant_admin toward POS/hardware setup. Has no close (x) —
 * the user must pick Go to Hardware or Integrate Later.
 */
@Component({
  selector: 'app-agreement-success-modal',
  standalone: true,
  templateUrl: './agreement-success-modal.component.html',
  styleUrl: './agreement-success-modal.component.css',
})
export class AgreementSuccessModalComponent {
  @Output() goToHardware = new EventEmitter<void>();
  @Output() integrateLater = new EventEmitter<void>();
}
